import { useTracking } from 'react-tracking';
import Media from 'react-media';
import {
  InsiderTradingDataTable,
  InsiderTradingAccordion,
} from '@/pages/CompanyReport/components/InsiderTradingTransactions';
import { useTheme } from '@simplywallst/ui-core';
import { ViewMode } from '@/pages/CompanyReport/enum';
import ListTruncator from '@/components/ListTruncator';

export interface InsiderTradingTransactionsProps {
  filingDate: string;
  transactionType: string;
  transactionValue: string;
  ownerName: string;
  ownerType: string;
  teamTitle: string;
  boardTitle: string;
  shares: string;
  priceMax: string;
}

export interface Props {
  data: InsiderTradingTransactionsProps[];
  uniqueSymbol: string;
  viewMode: ViewMode;
}

const InsiderTradingTransactions = ({
  data,
  uniqueSymbol,
  viewMode,
}: Props) => {
  const theme = useTheme();
  const { Track } = useTracking({
    type: 'track',
    subject: 'InsiderTradingTransactions',
    listLength: data.length,
  });
  return data.length > 0 ? (
    <Track>
      <Media query={{ minWidth: theme.mdMinRaw }}>
        {(matches) => {
          if (matches || viewMode === ViewMode.Print) {
            return data.length <= 10 ? (
              <InsiderTradingDataTable
                data={data}
                uniqueSymbol={uniqueSymbol}
              />
            ) : (
              <ListTruncator viewMode={viewMode} minHeight={360}>
                <InsiderTradingDataTable
                  data={data}
                  uniqueSymbol={uniqueSymbol}
                />
              </ListTruncator>
            );
          }

          //For smaller screen widths
          return <InsiderTradingAccordion data={data} />;
        }}
      </Media>
    </Track>
  ) : null;
};

export default InsiderTradingTransactions;
